import {
  AlertDialog,
  InputDropdown,
  Section,
  Text,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { isAxiosError } from 'axios'

import { generateReport as generateReportPost } from '@/api/post'

import {
  Row,
  SearchBarContainer,
  StyledButton,
  StyledInputLabel,
  StyledText,
} from './style'
import { ButtonsContainer } from '@/components/ImageCard/style'
import TextFieldInput from '@/components/TextFieldInput'
import { useApp } from '@/stores/AppStore'
import { useSearchReport } from '@/stores/SearchReportStore'
import { SITES } from '@/utils/constants'
import { downloadBase64, getDateNow, getDateTimeNow } from '@/utils/utils'

const DataToEditSection: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const { setIsLoading, user, remark } = useApp()
  const {
    site,
    startDate,
    endDate,
    orderItem,
    types,
    clientHeader,
    setClientHeader,
    descriptionHeader,
    setDescriptionHeader,
    projectHeader,
    setProjectHeader,
    inspectionHeader,
    setInspectionHeader,
    pedidoItemHeader,
    setPedidoItemHeader,
    currentItem,
    testSelected,
    heatItems,
    processOrderItems,
    resultItemsSelected,
    remark1,
    setRemark1,
    remark2,
    setRemark2,
    remark3,
    setRemark3,
    completeHeaderItem,
    setCompleteHeaderItem,
  } = useSearchReport()

  const [showConfirm, setShowConfirm] = useState(false)
  const [descriptionDocuments] = useState('')

  const [mapRemark1, setMapRemark1] = React.useState<string[]>([])
  const [mapRemark2, setMapRemark2] = React.useState<string[]>([])
  const [mapRemark3, setMapRemark3] = React.useState<string[]>([])

  useEffect(() => {
    const foundRemark = remark?.find((item) => item.type === testSelected?.type)

    setRemark1('')
    setRemark2('')
    setRemark3('')

    setMapRemark1(
      foundRemark?.remarks
        .filter((item) => item.line === '1')
        .map((item) => item.remark) ?? []
    )
    setMapRemark2(
      foundRemark?.remarks
        .filter((item) => item.line === '2')
        .map((item) => item.remark) ?? []
    )
    setMapRemark3(
      foundRemark?.remarks
        .filter((item) => item.line === '3')
        .map((item) => item.remark) ?? []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testSelected])

  useEffect(() => {
    if (currentItem) {
      setCompleteHeaderItem({
        remark1,
        remark2,
        remark3,
        sampleType: types,
        orderProcess: processOrderItems,
        startDate,
        endDate,
        customerChange: clientHeader,
        descriptionChange: descriptionHeader,
        inspectionChange: inspectionHeader,
        projectChange: projectHeader,
        orderItemChange: orderItem,
      })
    } else {
      setCompleteHeaderItem({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentItem,
    remark1,
    remark2,
    remark3,
    types,
    processOrderItems,
    startDate,
    endDate,
    clientHeader,
    descriptionHeader,
    inspectionHeader,
    projectHeader,
    orderItem,
  ])

  const generateReport = async (
    justGenerateValue = false,
    generateExcel = false
  ) => {
    const elaborationPosition = user?.userPosition ?? ' '
    const elaborationName = user?.userName ?? ' '

    if (
      testSelected &&
      currentItem &&
      completeHeaderItem &&
      resultItemsSelected &&
      user &&
      user.userPosition
    ) {
      try {
        const result = await generateReportPost({
          email: user.email,
          user: user.userName,
          position: user.userPosition,
          test: testSelected,
          generate: true,
          dateNow: getDateNow(),
          testName: testSelected?.name,
          selected: resultItemsSelected,
          remark1,
          remark2,
          remark3,
          site: SITES.find((s) => s.name === site),
          heat: heatItems,
          documents: [],
          currentDate: getDateTimeNow().en,
          // requirements: this.requirementsValue,
          elaboration: elaborationName,
          elaboration_position: elaborationPosition,
          customFields: {
            completeHeaderItem,
            customer: clientHeader,
            description: descriptionHeader,
            inspection: inspectionHeader,
            project: projectHeader,
            orderItem: pedidoItemHeader,
            justGenerate: justGenerateValue,
            generateExcel,
          },
        })

        if (justGenerateValue)
          downloadBase64(
            document,
            result.completeFileName,
            result.report,
            atob(result.report)
          )
        // else showAlertSuccessTranslate('application.commons.sucess.operation');
      } catch (error) {
        console.log(error)
        if (isAxiosError(error)) {
          toast({
            title: 'Error',
            description: error.response?.data?.errorMessage ?? error.message,
            type: 'error',
          })
        } else {
          toast({
            title: 'Error',
            description: `${error}`,
            type: 'error',
          })
        }
      }
    }
  }

  const confirm = async () => {
    try {
      setIsLoading(true)
      setShowConfirm(false)
      await generateReport(true, false)
    } catch (error) {
      console.log(error)
      if (isAxiosError(error)) {
        toast({ title: 'Error', description: error.message, type: 'error' })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const onOutsideClickAlert = () => {
    setShowConfirm(false)
  }

  return (
    <Section.Root
      header={
        <Section.Header
          title={t<string>(
            'generateReport.dataToEditSection.title',
            'Data to edit the document'
          )}
          isCollapsable
        />
      }
    >
      <StyledText> {t('', 'HEADER')} </StyledText>
      <Row>
        <SearchBarContainer>
          <StyledInputLabel> Client </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setClientHeader(event?.target?.value)}
            placeholder={t('', 'Digite o Cliente')}
            width="100%"
            value={clientHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel> Description </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setDescriptionHeader(event?.target?.value)}
            placeholder={t('', 'Digite a Descrição')}
            width="100%"
            value={descriptionHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel> Inspection </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setInspectionHeader(event?.target?.value)}
            placeholder={t('', 'Digite a Inspeção')}
            width="100%"
            value={inspectionHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel> Pedido/Item [PO] </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setPedidoItemHeader(event?.target?.value)}
            placeholder={t('', 'Digite o Pedido/Item [PO]')}
            width="100%"
            value={pedidoItemHeader}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel> Project </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="actionNameInput"
            disabled={false}
            onChange={(event) => setProjectHeader(event?.target?.value)}
            placeholder={t('', 'Digite o site')}
            width="100%"
            value={projectHeader}
          />
        </SearchBarContainer>
      </Row>
      <StyledText> {t('', 'REMARKS')} </StyledText>
      <Row>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>('generateReport.dataToEditSection.remark1')}{' '}
          </StyledInputLabel>
          <InputDropdown.Root
            onValueChange={(value) => setRemark1(value)}
            trigger={
              <InputDropdown.Trigger
                placeholder={t<string>(
                  'generateReport.dataToEditSection.select'
                )}
                style={{
                  width: '15rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  boxSizing: 'border-box',
                }}
              />
            }
            defaultValue={remark1}
          >
            {mapRemark1.map((value) => {
              return (
                <InputDropdown.Item
                  key={`SelectItem-${value}`}
                  value={value?.toString()}
                >
                  {value}
                </InputDropdown.Item>
              )
            })}
          </InputDropdown.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>('generateReport.dataToEditSection.remark2')}{' '}
          </StyledInputLabel>
          <InputDropdown.Root
            onValueChange={(value) => setRemark2(value)}
            trigger={
              <InputDropdown.Trigger
                placeholder={t<string>(
                  'generateReport.dataToEditSection.select'
                )}
                style={{
                  width: '15rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  boxSizing: 'border-box',
                }}
              />
            }
            defaultValue={remark2}
          >
            {mapRemark2.map((value) => {
              return (
                <InputDropdown.Item
                  key={`SelectItem-${value}`}
                  value={value?.toString()}
                >
                  {value}
                </InputDropdown.Item>
              )
            })}
          </InputDropdown.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {' '}
            {t<string>('generateReport.dataToEditSection.remark3')}{' '}
          </StyledInputLabel>
          <InputDropdown.Root
            onValueChange={(value) => setRemark3(value)}
            trigger={
              <InputDropdown.Trigger
                placeholder={t<string>(
                  'generateReport.dataToEditSection.select'
                )}
                style={{
                  width: '15rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  boxSizing: 'border-box',
                }}
              />
            }
            defaultValue={remark3}
          >
            {mapRemark3.map((value) => {
              return (
                <InputDropdown.Item
                  key={`SelectItem-${value}`}
                  value={value?.toString()}
                >
                  {value}
                </InputDropdown.Item>
              )
            })}
          </InputDropdown.Root>
        </SearchBarContainer>
      </Row>
      <AlertDialog
        open={showConfirm}
        variant="warn"
        title={`${t<string>('generateReport.dataToResult.hasDocuments')}`}
        description={descriptionDocuments}
        onOpenChange={onOutsideClickAlert}
        close={onOutsideClickAlert}
        footer={
          <ButtonsContainer>
            <StyledButton
              onClick={onOutsideClickAlert}
              key="cancel-button"
              variant="warnWithBorders"
            >
              <Text>{t<string>('application.button.cancel')}</Text>
            </StyledButton>
            <StyledButton
              onClick={confirm}
              key="confirm-button"
              variant="warnWithoutBorders"
            >
              <Text>{t<string>('application.button.confirm')}</Text>
            </StyledButton>
          </ButtonsContainer>
        }
      />
    </Section.Root>
  )
}

export default DataToEditSection
